import CarListPage from "../pages/car/carIndex";
import AddCar from "../pages/car/addCar";
import EditCar from "../pages/car/editCar";

const carRoutes = [
  {
    path: "car",
    element: <CarListPage />,
  },
  {
    path: "car/add",
    element: <AddCar />,
  },
  {
    path: "car/edit/:id",
    element: <EditCar />,
  },
];

export default carRoutes;